module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "frontmatter",
      "title": "Acknowledgments"
    }
  }, [_c('h1', {
    staticClass: "common_h"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_ix",
      "title": "ix"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253059833_Contents#r_ack",
      "id": "ack"
    }
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("CKNOWLEDGMENTS")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent_para"
  }, [_vm._v("While the shortcomings in this work are mine, whatever insights it might hold grow from conversations I’ve held with people far wiser than myself. I would like to offer them my thanks.")]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("The people at the University of Oregon deserve my deep appreciation for letting me be part of such a genuine scholarly community. I thank my fellow Oregon grads, especially Alex Stotts, Kim Garchar, John Shuford, Maurice Hamington, Greg Johnson, Don Morse, Ken Pendleton, and Lorraine Brundige.")]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("I owe great thanks to my professors, including Nancy Tuana, Mark Johnson, John Lysaker, Cheney Ryan, and Naomi Zack. My friend and mentor Scott Pratt has my eternal gratitude for showing me such patience and respect and making possible my life as an academic.")]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("This work would have been impossible without the Society for the Advancement of American Philosophy, whose members exemplify the very best of the pragmatist spirit. I extend my thanks to all the people who make SAAP such a welcoming environment, and especially to Paul Taylor, Eddie Glaude, Judith Green, Shannon Sullivan, Colin Koopman, Lee McBride, Erin McKenna, Leonard Harris, Michael Sullivan, and David McClean.")]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("Good fortune brought me to Eastern Washington University, where I befriended many people who’ve helped immensely with this work. I thank my students for indulging my idiosyncrasies and offer special thanks and encouragement to Caleb Woodrow, Jeff Ewing, Richard Devenport, Chris Phipps, "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_x",
      "title": "x"
    }
  }, [_vm._v("Rommel Watson, Jordan Biltof, Natasha Vanderlinden, and Evan Buelt. I thank my wonderful colleagues at Eastern, including Tracy McHenry, Dana Elder, Scott Finnie, Wayne Kraft, Steve Scott, Garry Kenney, Nancy Nelson, Lynn Briggs, Gary Krug, and Pam Schierman. I thank Ruth Galm at the Office of Grant and Research Development and Helen Bergland from the Teaching and Learning Center for their help in securing vital research grants. Most of all, I acknowledge the love and support I’ve received from two outstanding people: Mimi Marinucci, whose trust in me made real my dream of being a teacher, and Kevin Decker, whose humor, intelligence, and passion embody the ideal of the Deweyan public intellectual.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("Two dear friends, Leif Solem and Basem Aly, receive my thanks for reading and improving early drafts of this work. I had the pleasure of working with many great professionals at Indiana University Press. I offer great thanks to Dee Mortensen and John Stuhr for their patient advice at every step of the process. I also thank Carol Kennedy for her attentive and insightful copyediting.")]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("Everything good in my life rests on my family’s love and support. I thank my parents, Ed and Joan, for their constant love and confidence. I thank Ed, Heather, Lissa, Gary, Peter, Gail, Sue, and Michael, my brothers, sisters, and their spouses, for their generosity and care. Most of all I thank the love of my life, Becca, for her patience, affection, and inspiration. Finally, I thank my two wonderful children, Sylvia and Liam, for reminding me that love is the most important gift in life.")]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("Some passages in this book were published previously. Brief passages scattered across many "), _c('span', {
    attrs: {
      "href": "#/text/9780253059833_Chapter04#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapters (4")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/text/9780253059833_Chapter05#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/text/9780253059833_Chapter06#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/text/9780253059833_Chapter08#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/text/9780253059833_Chapter09#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/text/9780253059833_Chapter10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")]), _vm._v(", and the conclusion) were previously published in “Is There a White Gift?: Pragmatist Responses to the Problem of Whiteness,” "), _c('i', [_vm._v("Transactions of the Charles S. Peirce Society")]), _vm._v(" 41, no. 4 (2005). Also, much of my discussion on contemporary debates on whiteness in "), _c('span', {
    attrs: {
      "href": "#/text/9780253059833_Chapter07#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 7")]), _vm._v(" was previously published in “Beyond the Pale: A Pragmatist Approach to Whiteness Studies,” "), _c('i', [_vm._v("Philosophy and Social Criticism")]), _vm._v(" 31, no. 3 (2005).")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4cd496c0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780253059833_Acknowledgments.vue
// module id = 72
// module chunks = 0